import React from "react";

export default function InternalServerError() {
    return (
        <>
           <img className="error-message" src="/images/error-images/500-error.svg" alt="500" style={{filter: `grayscale(90%)`}} />
        </>
    );  
}